// slice/clientProviderSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const LARAVEL_RECENT_CHAT_API = process.env.REACT_APP_LARAVEL_API

// Provider list
export const getClientProviderList = createAsyncThunk(
  "client/getClientProviders",
  async ({ filters = {}, token }, thunkAPI) => {
    try {
      const type = 'provider';
      const queryParams = new URLSearchParams({
        ...filters,
      });
      // const res = await axios.get(`${BACKEND_URL}/provider/chat-list?${queryParams}`);
      const res = await axios.get(
        `${LARAVEL_RECENT_CHAT_API}/admin/chatify/recent-chat/${type}`, {
          headers: { Token: `${token}` },
        });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers");
    }
  }
);

// Admin list
export const getAdminUserList = createAsyncThunk(
  "client/getAdminUsers",
  async ({ filters = {}, token }, thunkAPI) => {
    try {
      const type = 'admin';
        const queryParams = new URLSearchParams({
        ...filters,
      });
      // const res = await axios.get(`${BACKEND_URL}/user/chat-list?${queryParams}`);
      const res = await axios.get(
        `${LARAVEL_RECENT_CHAT_API}/admin/chatify/recent-chat/${type}`, {
          headers: { Token: `${token}` },
        });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch admin users");
    }
  }
);

const clientChatListSlice = createSlice({
  name: "clientChatListing",
  initialState: {
    clientProviders: [],
    clientLastMessages: [],
    adminUsers: [],
    adminLastMessages: [],
    pagination: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      // Providers
      .addCase(getClientProviderList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClientProviderList.fulfilled, (state, action) => {
        state.clientProviders = action.payload.user;
        state.clientLastMessages = action.payload.latestMessages;
        state.pagination = {
          current_page: action.payload.current_page,
          last_page: action.payload.last_page,
          total: action.payload.total,
        };
        state.loading = false;
      })
      .addCase(getClientProviderList.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })

      // Admins
      .addCase(getAdminUserList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAdminUserList.fulfilled, (state, action) => {
        state.adminUsers = action.payload.user;
        state.adminLastMessages = action.payload.latestMessages;
        state.loading = false;
      })
      .addCase(getAdminUserList.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default clientChatListSlice.reducer;
